export const CATEGORY_LABELS = {
  financing: "Financing", inspections: "Inspections", cleaning: "Cleaning", moving: "Moving",
  contractors: "Contractors", landscaping: "Landscaping", insurance: "Insurance", title: "Title Services", other: "Local Service",
};
export const LISTING_STATUS_LABELS = { coming_soon: "Coming Soon", active: "For Sale", pending: "Pending", sold: "Sold", off_market: "Off Market" };
export const HOA_PERIOD_LABELS = { Monthly: "/mo", Quarterly: "/qtr", Annually: "/yr" };
